/* tlc-shared.js - extracted 2026-08-15 (audit F9).
   Both blocks are self-contained IIFEs that were identical on every page.
   Loaded with defer, so they now run after the DOM is parsed rather than
   mid-body - strictly safer for the getElementById calls at the top of the
   quick-view module. defer preserves order and still precedes
   DOMContentLoaded, which the wishlist module listens for. */

/* ===== quick view ===== */
(function(){
  var overlay    = document.getElementById('tlc-qv-overlay');
  var modal      = document.getElementById('tlc-qv-modal');
  var closeBtn   = document.getElementById('tlc-qv-close');
  var imgEl      = document.getElementById('tlc-qv-img');
  var typeEl     = document.getElementById('tlc-qv-type');
  var titleEl    = document.getElementById('tlc-qv-title');
  var ratingWrap = document.getElementById('tlc-qv-rating');
  var ratingVal  = document.getElementById('tlc-qv-rating-val');
  var priceNow   = document.getElementById('tlc-qv-price-now');
  var priceWas   = document.getElementById('tlc-qv-price-was');
  var priceSave  = document.getElementById('tlc-qv-price-save');
  var descEl     = document.getElementById('tlc-qv-desc');
  var variantsEl = document.getElementById('tlc-qv-variants');
  var addBtn     = document.getElementById('tlc-qv-add');
  var pdpLink    = document.getElementById('tlc-qv-pdp');

  var selectedVariant = null;

  function money(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function open(handle, url) {
    overlay.classList.add('is-open');
    modal.classList.add('is-loading');
    pdpLink.href = url;
    document.body.style.overflow = 'hidden';

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.json(); })
      .then(function(p){ populate(p); modal.classList.remove('is-loading'); })
      .catch(function(){
        modal.classList.remove('is-loading');
        titleEl.textContent = 'Could not load product.';
      });
  }

  function populate(p) {
    imgEl.src = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x600$1$2')
      : '';
    imgEl.alt = p.title;
    typeEl.textContent = p.type || '';
    titleEl.textContent = p.title;
    pdpLink.href = '/products/' + p.handle;

    var stripped = (p.body_html || '').replace(/<[^>]*>/g, '').trim();
    descEl.textContent = stripped.length > 200 ? stripped.substring(0, 200) + '…' : stripped;

    ratingWrap.style.display = 'none';

    variantsEl.textContent = '';
    if (p.variants.length > 1) {
      p.variants.forEach(function(v, i) {
        var btn = document.createElement('button');
        btn.className = 'qv-var' + (i === 0 ? ' is-on' : '');
        btn.textContent = v.title;
        btn.disabled = !v.available;
        btn.dataset.vid = v.id;
        btn.addEventListener('click', function() {
          variantsEl.querySelectorAll('.qv-var').forEach(function(b){ b.classList.remove('is-on'); });
          btn.classList.add('is-on');
          selectVariant(v);
        });
        variantsEl.appendChild(btn);
      });
    }

    selectVariant(p.variants[0]);
  }

  function selectVariant(v) {
    selectedVariant = v;
    priceNow.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      priceWas.textContent = money(v.compare_at_price);
      priceWas.style.display = '';
      priceSave.textContent = 'Save ' + pct + '%';
      priceSave.style.display = '';
    } else {
      priceWas.style.display = 'none';
      priceSave.style.display = 'none';
    }
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    selectedVariant = null;
  }

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

  addBtn.addEventListener('click', function() {
    if (!selectedVariant || !selectedVariant.available) return;
    addBtn.textContent = 'Adding…';
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: selectedVariant.id, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function() {
      addBtn.textContent = 'Added!';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function() {
        close();
        var toggle = document.querySelector('[data-cart-toggle],[aria-controls="cart-drawer"]');
        if (toggle) toggle.click();
      }, 700);
    })
    .catch(function() {
      addBtn.textContent = 'Add to bag';
      addBtn.disabled = false;
    });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.tlc-pcard__qv');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.dataset.handle, btn.dataset.url);
  });
})();

/* ===== wishlist ===== */
(function(){
  if(window.__tlcWishBound) return; window.__tlcWishBound = true;
  var KEY='tlc_wishlist';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function toggle(h){ var a=read(), i=a.indexOf(h); if(i>-1)a.splice(i,1); else a.unshift(h); write(a); }
  function remove(h){ var a=read(), i=a.indexOf(h); if(i>-1){a.splice(i,1); write(a);} }
  function fmt(c){ return '₹'+Math.round(c/100).toLocaleString('en-IN'); }
  function el(tag, cls){ var n=document.createElement(tag); if(cls) n.className=cls; return n; }

  function paint(){
    var saved=read();
    document.querySelectorAll('[data-tlc-wish]').forEach(function(b){
      b.setAttribute('aria-pressed', saved.indexOf(b.getAttribute('data-tlc-wish'))>-1 ? 'true':'false');
    });
    var n=saved.length;
    document.querySelectorAll('[data-tlc-wish-count]').forEach(function(c){ c.textContent=n; c.style.display = n>0 ? '' : 'none'; });
    document.querySelectorAll('[data-tlc-wish-count-text]').forEach(function(c){ c.textContent=n; });
  }

  function emptyMsg(body, msg){ var p=el('p','tlc-wish-empty'); p.textContent=msg; body.appendChild(p); }

  function makeItem(p){
    var img=p.featured_image||(p.images&&p.images[0])||'';
    if(img && img.indexOf('//')===0) img='https:'+img;
    var src=img ? (img.indexOf('?')>-1?img+'&width=200':img+'?width=200') : '';
    var item=el('div','tlc-wish-item');
    var media=el('a','tlc-wish-item__media'); media.href=p.url;
    if(src){ var im=el('img'); im.src=src; im.alt=''; im.loading='lazy'; media.appendChild(im); }
    var b=el('div','tlc-wish-item__b');
    var t=el('a','tlc-wish-item__t'); t.href=p.url; t.textContent=p.title||'';
    var pr=el('p','tlc-wish-item__p');
    if(p.compare_at_price>p.price){ var s=el('s'); s.textContent=fmt(p.compare_at_price); pr.appendChild(s); pr.appendChild(document.createTextNode(' ')); }
    pr.appendChild(document.createTextNode(fmt(p.price)));
    var act=el('div','tlc-wish-item__act');
    var view=el('a','tlc-wish-item__view'); view.href=p.url; view.textContent='View';
    var rm=el('button'); rm.type='button'; rm.setAttribute('data-tlc-wish-remove', p.handle); rm.textContent='Remove';
    act.appendChild(view); act.appendChild(rm);
    b.appendChild(t); b.appendChild(pr); b.appendChild(act);
    item.appendChild(media); item.appendChild(b);
    return item;
  }

  function renderDrawer(){
    var body=document.getElementById('tlc-wish-body'); if(!body) return;
    var saved=read();
    body.textContent='';
    if(!saved.length){ emptyMsg(body, 'Nothing saved yet. Tap the heart on any product to keep it here.'); return; }
    var loading=el('p','tlc-wish-loading'); loading.textContent='Gathering your saved pieces…'; body.appendChild(loading);
    Promise.all(saved.map(function(h){
      return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){ return r.ok?r.json():null; }).catch(function(){ return null; });
    })).then(function(items){
      body.textContent='';
      var any=false;
      items.forEach(function(p){ if(p){ body.appendChild(makeItem(p)); any=true; } });
      if(!any) emptyMsg(body, 'Nothing saved yet.');
    });
  }

  function openD(){ var d=document.getElementById('tlc-wish-drawer'); if(!d)return; d.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; renderDrawer(); }
  function closeD(){ var d=document.getElementById('tlc-wish-drawer'); if(!d)return; d.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }

  document.addEventListener('click', function(e){
    var t=e.target.closest('[data-tlc-wish]');
    if(t){ e.preventDefault(); e.stopPropagation(); toggle(t.getAttribute('data-tlc-wish')); paint(); return; }
    if(e.target.closest('[data-tlc-wish-open]')){ e.preventDefault(); openD(); return; }
    if(e.target.closest('[data-tlc-wish-close]')){ e.preventDefault(); closeD(); return; }
    var rm=e.target.closest('[data-tlc-wish-remove]');
    if(rm){ e.preventDefault(); remove(rm.getAttribute('data-tlc-wish-remove')); paint(); renderDrawer(); return; }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeD(); });
  function init(){ paint(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', paint);
  window.addEventListener('storage', function(e){ if(e.key===KEY){ paint(); renderDrawer(); } });
})();


(function () {
  if (window.__tlcWhatsAppOverlayGuard) return;
  window.__tlcWhatsAppOverlayGuard = true;

  var widgets = '.WhatsAppButton__root,#whatsapp-first-time-popup,#tlc-wa-btn';
  var explicit = '#tlcnDrawer.open,.mega.open,#tlcwp.on,.tlcsr.is-open .tlcsr-sug,x-drawer[open],cart-drawer[open],search-drawer[open],facet-drawer[open],filter-drawer[open],dialog[open],.drawer[open],.drawer.open,.drawer.is-open';
  var candidates = '#tlcnDrawer,.mega,x-drawer,cart-drawer,search-drawer,facet-drawer,filter-drawer,dialog,.drawer,[role="dialog"],[aria-modal="true"],.tlc-wish-drawer,.tlcsr-sug,#cashfree-modal-container iframe';
  var focusables = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]';
  var saved = new Map();

  function visible(el) {
    var hidden = el.closest('[hidden],[aria-hidden="true"]');
    var manualOffer = hidden && hidden.id === 'tlcwp' && hidden.classList.contains('on') && !hidden.hidden && !hidden.parentElement.closest('[hidden],[aria-hidden="true"]');
    if (hidden && !manualOffer) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (el.matches(explicit)) return true;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
  }

  function isBlocker(el) {
    if (el.closest(widgets)) return false;
    if (el.matches('#tlcnDrawer,.mega') && !el.classList.contains('open')) return false;
    if (el.matches('x-drawer,cart-drawer,search-drawer,facet-drawer,filter-drawer,dialog') && !el.hasAttribute('open')) return false;
    if (el.tagName === 'IFRAME') {
      var rect = el.getBoundingClientRect();
      if (rect.width < 250 || rect.height < 250) return false;
    }
    return visible(el);
  }

  function moveFocus(blocker) {
    var target = Array.prototype.find.call(blocker.querySelectorAll(focusables), visible);
    if (target) target.focus({ preventScroll: true });
    else if (blocker.tagName === 'IFRAME') blocker.focus();
    else if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  }

  function setAttribute(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function restoreAttribute(el, name, value) {
    if (value === null) el.removeAttribute(name);
    else setAttribute(el, name, value);
  }

  function restoreWidget(state, el) {
    el.removeAttribute('data-tlc-wa-suspended');
    restoreAttribute(el, 'inert', state.inert);
    restoreAttribute(el, 'aria-hidden', state.ariaHidden);
  }

  function sync() {
    var blocker = Array.prototype.find.call(document.querySelectorAll(candidates), isBlocker);
    if (blocker) {
      document.querySelectorAll(widgets).forEach(function (el) {
        if (!saved.has(el)) saved.set(el, { inert: el.getAttribute('inert'), ariaHidden: el.getAttribute('aria-hidden') });
        if (el.contains(document.activeElement)) moveFocus(blocker);
        setAttribute(el, 'data-tlc-wa-suspended', '');
        setAttribute(el, 'inert', '');
        setAttribute(el, 'aria-hidden', 'true');
      });
    } else {
      saved.forEach(restoreWidget);
      saved.clear();
    }
    saved.forEach(function (state, el) {
      if (!el.isConnected) { restoreWidget(state, el); saved.delete(el); }
    });
  }

  function related(node) {
    return node.nodeType === 1 && (node.matches(candidates + ',' + widgets) || node.querySelector(candidates + ',' + widgets));
  }

  new MutationObserver(function (records) {
    if (records.some(function (record) {
      if (record.type === 'childList') return Array.prototype.some.call(record.addedNodes, related) || Array.prototype.some.call(record.removedNodes, related);
      return related(record.target);
    })) sync();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-modal', 'name', 'src'] });

  document.addEventListener('focusin', function (event) {
    if (event.target.closest(widgets)) sync();
  });
  ['dialog:after-show', 'dialog:after-hide', 'shopify:section:load'].forEach(function (name) { document.addEventListener(name, sync); });
  window.addEventListener('pageshow', sync);
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();
